import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import {
  Box,
  Container,
  Paper,
  Button,
  Typography,
  CircularProgress
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const LoginPage: React.FC = () => {
  const { user, loginWithDiscord, loading } = useAuth();
  const location = useLocation();

  const from = (location.state as any)?.from?.pathname || '/admin';

  if (user) {
    return <Navigate to={from} replace />;
  }

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            BasketBase Admin
          </Typography>
          <Typography variant="body1" color="text.secondary" align="center" sx={{ mb: 3 }}>
            Sign in with Discord to access the admin panel
          </Typography>

          <Button
            fullWidth
            variant="contained"
            sx={{ 
              mt: 3, 
              mb: 2,
              backgroundColor: '#5865F2',
              '&:hover': {
                backgroundColor: '#4752C4',
              }
            }}
            onClick={loginWithDiscord}
          >
            Login with Discord
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default LoginPage;
